import React, { FunctionComponent, useState } from 'react';
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  Dropdown,
  getTheme,
  IDropdownOption,
  Stack,
  Text,
  TextField
} from '@fluentui/react';
import { settingsDropdownRoleStyles, settingsFieldStyles } from '../SettingsStyles';
import { GroupRole, RoleType, updateGroupRole } from '../../../services/groupRoles.service';
import { SalusPrimaryButton } from '../../shared/SalusPrimaryButton';
import { trackException } from '../../../services';
import { AxiosError } from 'axios';

export const RoleDropDownOptions: IDropdownOption[] = [
  {
    key: RoleType.Admin,
    text: RoleType.Admin
  },
  {
    key: RoleType.Moderator,
    text: RoleType.Moderator
  }
];

interface EditGroupRoleDialogProps {
  showEditGroupRoleDialog: boolean;
  setShowEditGroupRoleDialog: React.Dispatch<React.SetStateAction<boolean>>;
  activeGroupRole: GroupRole;
}

export const EditGroupRoleDialog: FunctionComponent<EditGroupRoleDialogProps> = (props): JSX.Element => {
  const { palette, fonts } = getTheme();
  const [newRole, setNewRole] = useState<RoleType>();
  const [roleUpdated, setRoleUpdated] = useState(false);

  const onEditGroup = () => {
    if (newRole) {
      const updatedGroupRole = { ...props.activeGroupRole, role: newRole };
      updateGroupRole(updatedGroupRole)
        .then(() => {
          setRoleUpdated(true);
        })
        .catch((err: AxiosError) => {
          err.message = 'EditGroupRoleDialog: ' + err.message;
          trackException(err);
        });
    }
  };

  const onCloseDialog = () => {
    props.setShowEditGroupRoleDialog(false);
  };

  return (
    <Dialog
      isBlocking={false}
      hidden={!props.showEditGroupRoleDialog}
      dialogContentProps={{
        title: 'Edit group'
      }}
      modalProps={{
        overlay: {
          isDarkThemed: true
        }
      }}
    >
      {!roleUpdated ? (
        <>
          <Stack style={{ marginBottom: 18, marginTop: -18 }}>
            <TextField
              label="User group"
              value={props.activeGroupRole.groupName}
              styles={settingsFieldStyles(palette, fonts, '100%')}
              disabled
            />
          </Stack>
          <Stack style={{ marginBottom: 36 }}>
            <Dropdown
              disabled={roleUpdated}
              label={'Role'}
              placeholder={'Select a role'}
              options={RoleDropDownOptions}
              defaultValue={props.activeGroupRole.role}
              defaultSelectedKey={props.activeGroupRole.role}
              styles={settingsDropdownRoleStyles(palette, fonts, '100%')}
              onChange={(e, option): void => {
                setNewRole(option?.key as RoleType);
              }}
              required
            />
          </Stack>
        </>
      ) : (
        <Text>{'Success!'}</Text>
      )}

      <DialogFooter>
        <SalusPrimaryButton
          disabled={!newRole || newRole === props.activeGroupRole.role || roleUpdated}
          onClick={onEditGroup}
          text="Update"
        />
        <DefaultButton onClick={onCloseDialog} text={roleUpdated ? 'Done' : 'Cancel'} />
      </DialogFooter>
    </Dialog>
  );
};
